import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=519fad47"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Pages/UserProfileComponents/ChangePassword.vue
// module id = 2281
// module chunks = 31